import { Viewport } from "reactflow"
import { supabase } from "../database/SupabaseConnector"
import debounce from "lodash.debounce"

export const updateViewport = debounce(
  async (viewport: Viewport, canvasId: string, userId: string) => {
    return await supabase
      .from("user_settings")
      .update({
        canvas_x: viewport.x,
        canvas_y: viewport.y,
        canvas_zoom: viewport.zoom,
      })
      .eq("canvas_id", canvasId)
      .eq("user_id", userId)
  },
  2000
)
